import { BigNumber } from "ethers";
import { parseEther } from "ethers/lib/utils";
import { TraitSale } from "types";
import traits from "config/traits.csv";

export const fetchTraitSales = async (): Promise<TraitSale[]> => {
  return traits.map(([tokenId, name]: [number, string]) => ({
    tokenId,
    name,
    honeyConsumptionRequirement: BigNumber.from("0"),
    price: parseEther("71000"),
    counter: 0,
    maxSupply: 10,
    saleActive: true,
  }));
};
